import {
  ArrowRight,
  Bell,
  ClipboardList,
  HousePlus,
  Laptop,
  Stethoscope,
} from 'lucide-react';

const SERVICE_CARDS = [
  {
    title: 'Telemedicina',
    description: 'Consultas online com médicos especialistas.',
    icon: Laptop,
  },
  {
    title: 'Pronto atendimento',
    description: 'Atendimento rápido para imprevistos e urgências.',
    icon: Stethoscope,
  },
  {
    title: 'Atendimento domiciliar',
    description: 'Profissionais de saúde até você.',
    icon: HousePlus,
  },
  {
    title: 'Prontuário digital',
    description: 'Seu histórico médico sempre acessível.',
    icon: ClipboardList,
  },
  {
    title: 'Lembretes',
    description: 'Não perca consultas e exames.',
    icon: Bell,
  },
] as const;

export function LandingServices() {
  return (
    <section id="sobre" className="scroll-mt-20 bg-white">
      <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6 sm:py-16 lg:px-8">
        <div className="max-w-xl">
          <h2 className="text-3xl font-bold tracking-tight text-neutral-900 sm:text-4xl">
            Tudo que você precisa, <span className="text-teal-700">em um só lugar</span>
          </h2>
          <p className="mt-3 text-base leading-relaxed text-neutral-600">
            Conectamos você a profissionais de saúde onde estiver, com qualidade e
            humanização.
          </p>
          <a
            href="#como-funciona"
            className="mt-6 inline-flex items-center gap-1.5 rounded-lg border border-teal-600 bg-white px-4 py-2 text-sm font-medium text-teal-800 transition-colors hover:bg-teal-50"
          >
            Saiba mais
            <ArrowRight className="size-4" aria-hidden />
          </a>
        </div>

        <ul className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
          {SERVICE_CARDS.map(({ title, description, icon: Icon }) => (
            <li
              key={title}
              className="rounded-2xl border border-neutral-200 bg-white p-5 shadow-sm"
            >
              <span className="inline-flex size-10 items-center justify-center rounded-lg bg-teal-50 text-teal-700">
                <Icon className="size-5" aria-hidden />
              </span>
              <h3 className="mt-4 text-base font-semibold text-neutral-900">{title}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-neutral-600">{description}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
